<template>
    <router-view />
    <AlertMain />
</template>
<script setup>
    import AlertMain from '@/components/tooles/alert/AlertMain.vue';
</script>
<style>
    *{
        font-family: system-ui !important;
    }
</style>